import ZeissButton from '@components/button';
import ZeissModal from '@components/zeiss-modal';
import { Space } from 'antd';
import './index.scss';
export const RemarkPopup = ({ open, handleCancel, details }: any) => {
  return (
    <ZeissModal
      open={open}
      width={520}
      centered
      footer={null}
      onCancel={handleCancel}
    >
      <div className="pc-subLayout">
        <div className="pc-sub-title">备注</div>
        <div>
          <div className="pc-sub-remark-label">
            操作：<span>{details.subjectMatterStatusValue}</span>
          </div>
          <div className="pc-sub-remark-label">
            原因：<span>{details.unrelatedReasonValue}</span>
          </div>
          <div className="pc-sub-remark-label">
            备注：<span>{details.subjectMatterRemark}</span>
          </div>
        </div>
        <Space className="pc-matter-createAnn-footer" size="middle">
          <ZeissButton
            type="primary"
            className="pc-createAnn-sales"
            onClick={handleCancel}
          >
            我知道了
          </ZeissButton>
        </Space>
      </div>
    </ZeissModal>
  );
};
